import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import PostAddIcon from "@mui/icons-material/PostAdd";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";

import Confirm from "../../components/Confirm";
import OperationItem from "./OperationItem";

import { getOperations, deleteOperationById, updateOperation } from "../../api/operations";

const OperationsTable = ({ match, history }) => {
  const { t } = useTranslation();
  const [operations, setOperations] = useState([]);
  const [selectedOperationId, setSelectedOperationId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(id) {
    setSelectedOperationId(id);
    setIsDeleteModalShow(true);
  }

  function onEdit(id) {
    history.push(`${match.path}/${id}`);
  }

  async function onStatusChange(id, newStatus) {
    await updateOperation(id, { status: newStatus });

    setRefresh(refresh * -1);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteOperationById(selectedOperationId);
    }
    setIsDeleteModalShow(false);

    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      let newOperations = await getOperations();
      const operations = newOperations.map((operation) => ({
        ...operation,
        positions: operation.positions.map((position) => position.name).join(", "),
      }));
      setOperations(operations);
    })();
  }, [refresh]);

  return (
    <>
      <h2>{t("operations")}</h2>
      <TableComponent
        TopComponent={
          <Button size="small" onClick={() => history.push(`${match.path}/add_operation`)}>
            <PostAddIcon />
            {t("operations_page.add_action")}
          </Button>
        }
        header={[
          { title: t("id"), sort: "id", style: { width: "5%" } },
          { title: t("operation.name"), sort: "name" },
          { title: t("positions"), sort: "positions" },
          { title: t("status"), sort: "status", style: { width: "15%" } },
          { title: t("actions"), style: { width: "15%" } },
        ]}
        renderChildren={(operation) => (
          <OperationItem
            key={operation.id}
            onEdit={onEdit}
            onDelete={showDeleteModal}
            onStatusChange={onStatusChange}
            operation={operation}
          />
        )}
        items={operations}
        search={["name", "id", "positions"]}
        pagination
      />
      {isDeleteModalShow && selectedOperationId && (
        <Confirm title={t("operations_page.delete_action")} onConfirm={confirmDeleteModal}>
          <p>{t("operations_page.delete_confirm")}</p>
        </Confirm>
      )}
    </>
  );
};
export default OperationsTable;
